<template>
  <form @submit.prevent>
    <CModal
        :title.sync="title"
        color="info"
        :show.sync="show">


<b-form-file size="sm" v-model="form.file" class="mt-3" plain></b-form-file>

        <template #footer>
        <CButton @click="show = false" color="danger">Cancel</CButton>

        <CButton  v-if="mode === 'edit'" type="submit" v-on:click.prevent="upload()"  variant="outline" color="info">Upload</CButton>
      </template>
    </CModal>
  </form>
</template>

<script>
import moment from 'moment';

import EventBus from '@/eventBus';

import satelite from '@/services/satelitechurch'
import icare from '@/services/icare'
import member from '@/services/member'
import files from '@/services/files'

export default {
name: 'keperluanmodal',

  data () {
    return {
      show: false,
      title: 'Default Title',
      mode: '',
      form:{
        id: '',
        uuid: '',
        file: '',
        belongs_to: '',
      },
    }
  },
  mounted(){
    
  },

  
  created () {
    var self = this;
    EventBus.$on('OPEN_MODAL_MEMBER_PHOTO', (params) => {
      if(params.data){
        self.show = true;
        self.title = params.title;
        self.mode = params.mode;
        self.form.belongs_to = params.data
      }else{

      }
    });
  },

  methods: {
    open () {
      this.show = true;
    },
    close () {
      this.show = false;
    },
    upload(){
        let formData = new FormData();
        formData.append('file', this.form.file);
        formData.append('belongs_to', this.form.belongs_to);
        
        this.show = false;
        files.uploadIkidPhoto(formData)
        .then(res => {
            EventBus.$emit('PAGE_UPDATE_PHOTO', true)
            var params = {title: 'Success', mode:'success', data:res.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
            var params = {title: 'Error', mode:'danger', data:err.response.data.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
        console.log('get photo')
    },
  }
}
</script>

<style>
.center {
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>